import { CreateQuestionAnswerDto, QuestionAnswerDto, QuestionDto } from '@careapp-group/ng-sdk';
import { createAction, props } from '@ngrx/store';
import { CareAppListActionFactory } from '../action-factory';

export class QuestionsActions extends CareAppListActionFactory<QuestionDto> {
  get REQUEST_ANSWER_QUESTION() {
    return `[${this.type}][Request] Answer Question`;
  }
  get RESPONSE_SUCCESS_ANSWER_QUESTION() {
    return `[${this.type}][Response][Success] Answer Question`;
  }
  get RESPONSE_FAIL_ANSWER_QUESTION() {
    return `[${this.type}][Response][Fail] Answer Question`;
  }

  RequestAnswerQuestion(payload: { questionId: string; answer: CreateQuestionAnswerDto }) {
    return {
      type: this.REQUEST_ANSWER_QUESTION,
      payload,
    };
  }

  ResponseFailAnswerQuestion(payload: any) {
    return {
      type: this.RESPONSE_FAIL_ANSWER_QUESTION,
      payload,
    };
  }

  ResponseSuccessAnswerQuestion(payload: QuestionAnswerDto) {
    return {
      type: this.RESPONSE_SUCCESS_ANSWER_QUESTION,
      payload,
    };
  }

  requestQuestions = createAction(
    this.REQUEST_ALL,
    props<{ includeExpired: boolean; includeForAllRoles: boolean }>()
  );

  constructor(modelName: string) {
    super(modelName);
  }
}
export const Questions = new QuestionsActions(`Questions`);
